<div class="payment-block">
  <div>
    <p
      class="payment-block__pay"
      [ngClass]="{
        'theme-cartPopup__paymentTitle': parentComponent === 'Cart popup',
        'theme-cartPagePaymentBlock__paymentTitle': parentComponent === 'Checkout page'
      }"
    >
      {{ lg.cartPage.payText }}
    </p>
    <p
      class="payment-block__amount"
      [ngClass]="{
        'theme-cartPopup__discountTitle': parentComponent === 'Cart popup',
        'theme-cartPagePaymentBlock__discountTitle': parentComponent === 'Checkout page'
      }"
    >
      {{ lg.cartPage.amountDiscountText }}
    </p>
  </div>
  <div
    class="payment-block__price-container"
    [ngClass]="{
      'theme-cartPopup__price': parentComponent === 'Cart popup',
      'theme-cartPagePaymentBlock__price': parentComponent === 'Checkout page'
    }"
  >
    @if (cashbackAmount) {
      <p class="payment-block__price-cashback">{{ priceWithDiscount }} /</p>
    }
    <p class="payment-block__price-total">{{ priceWithDiscount - cashbackAmount }} {{ currencySign }}</p>
  </div>
</div>
@if (cashbackAmount) {
  <p class="payment-block__cashback">cashback: {{ cashbackAmount }} {{ currencySign }}</p>
}
